import { onLCP, onCLS, onINP, onFCP, Metric } from 'web-vitals';

const METRICS_ENDPOINT = '/api/v1/client-metrics';

interface ClientMetric {
    name: string;
    value: number;
    path: string;
}

interface ClientMetricsPayload {
    metrics: ClientMetric[];
}

function sendMetrics(metrics: ClientMetric[]) {
    const payload: ClientMetricsPayload = { metrics };
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });

    if (navigator.sendBeacon) {
        navigator.sendBeacon(METRICS_ENDPOINT, blob);
    } else {
        fetch(METRICS_ENDPOINT, {
            method: 'POST',
            body: blob,
            keepalive: true,
            headers: {
                'Content-Type': 'application/json'
            }
        }).catch(console.error);
    }
}

function handleMetric(metric: Metric) {
    const data: ClientMetric = {
        name: metric.name,
        value: metric.value,
        path: window.location.pathname
    };
    // Send immediately for now, or could batch
    sendMetrics([data]);
}

export function initObservability() {
    // Web Vitals
    onLCP(handleMetric);
    onCLS(handleMetric);
    onINP(handleMetric);
    onFCP(handleMetric);

    // External Link Tracking (Delegated)
    document.body.addEventListener('click', (e) => {
        const target = (e.target as Element).closest('a[data-track-apply="true"]');
        if (target) {
            // Track "Apply Click" - reusing the metrics endpoint for now or we could add a specific event endpoint.
            // Since we only have metrics endpoint, let's treat it as a custom metric or just a high-value log.
            // Actually, the plan mentions "Beacon API" for "Action: Click Apply Now".
            // The backend handler expects "FCP", "LCP", "CLS", "INP".
            // We should probably add "APPLY_CLICK" to the allowed list in DTO or create a separate endpoint/type.
            // Checking DTO... `validate:"required,oneof=FCP LCP CLS INP"`
            // Ah, strict validation. I need to update DTO to allow APPLY_CLICK.
            
            // For now, I will modify DTO to allow APPLY_CLICK in the next step.
            
            const data: ClientMetric = {
                name: "APPLY_CLICK",
                value: 1, // Counter
                path: window.location.pathname
            };
            sendMetrics([data]);
        }
    });
}
